import Http from "../engine/Http";
import { AuditableNamedIdentifiable, Dimension, Identifiable, ItemCompletedOrderRecord } from "../model/Items";
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";

interface Price {
  effective: number;
}

export interface Shape
extends AuditableNamedIdentifiable {
  name: string;
  unitPrice: Price;
  block: Dimension;
  material: Identifiable;
  unitQuantity: number;
  unitWeight: number;
}

export interface CompletedOrderShape
extends ItemCompletedOrderRecord {
  shapeId: number;
}

const useShapeApi = () => {
  const authenticationHeader = useAuthenticationHeader();

  const fetchShapes = (customerId: number, priceListId: number) : Promise<Shape[]> =>
    Http.get(`/api/customers/${customerId}/price-lists/${priceListId}/shapes`, [ authenticationHeader ]);

  const fetchShape = (customerId: number, priceListId: number, shapeId: number) : Promise<Shape> =>
    Http.get(`/api/customers/${customerId}/price-lists/${priceListId}/shapes/${shapeId}`, [ authenticationHeader ])

  const deleteShape = (customerId: number, priceListId: number, shapeId: number) =>
    Http.delete(`/api/customers/${customerId}/shapes/${shapeId}`, [ authenticationHeader ]);

  const fetchCompletedOrderShapes = (customerId: number): Promise<CompletedOrderShape[]> =>
    Http.get(`/api/customers/${customerId}/completedordershapes`, [ authenticationHeader ]);

  return {
    fetchShapes,
    fetchShape,
    deleteShape,
    fetchCompletedOrderShapes
  }
};

export default useShapeApi;